module.exports = __webpack_public_path__ + "img/img19.4fce062.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img19.png
// module id = 259
// module chunks = 0